<template>
<div class="client-setup">
    <div class="flex-page-sidebar">
        <nav class="nav-secondary">
            <div class="dropdown">
                <a class="btn dropdown-toggle" href role="button" id="navSecondaryMenuBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
                    Show: {{ activeTitle }}
                </a>
                <!-- {{ client.id }} -->
                <div class="dropdown-menu" aria-labelledby="navSecondaryMenuBtn">
                    <div>
                        <router-link :to="{name: 'client-setup-services'}" class="dropdown-item todo-item" :class="{'active': activeRoute == 'client-setup-services', 'todo-item-completed': setupStatus.services}" :id="`navSecondary-client-setup-services`">
                            <span class="todo-item-content">Services</span>
                        </router-link>

                        <router-link :to="{name: 'client-setup-companies'}" class="dropdown-item todo-item" :class="{'active': activeRoute == 'client-setup-companies', 'todo-item-completed': setupStatus.companies}" :id="`navSecondary-client-setup-companies`">
                            <span class="todo-item-content">Companies</span>
                        </router-link>

                        <router-link :to="{name: 'client-setup-locations'}" class="dropdown-item todo-item" :class="{'active': activeRoute == 'client-setup-locations', 'todo-item-completed': setupStatus.locations}" :id="`navSecondary-client-setup-locations`">
                            <span class="todo-item-content">Locations</span>
                        </router-link>

                        <router-link :to="{name: 'client-setup-pay-groups'}" class="dropdown-item todo-item" :class="{'active': activeRoute == 'client-setup-pay-groups', 'todo-item-completed': setupStatus.pay_groups}" :id="`navSecondary-client-setup-pay-groups`">
                            <span class="todo-item-content">Pay Groups</span>
                        </router-link>

                        <router-link :to="{name: 'client-setup-org-levels'}" class="dropdown-item todo-item" :class="{'active': activeRoute == 'client-setup-org-levels', 'todo-item-completed': setupStatus.org_levels}" :id="`navSecondary-client-setup-org-levels`">
                            <span class="todo-item-content">Organizational Levels</span>
                        </router-link>

                        <router-link :to="{name: 'client-setup-positions'}" class="dropdown-item todo-item" :class="{'active': activeRoute == 'client-setup-positions', 'todo-item-completed': setupStatus.positions}" :id="`navSecondary-client-setup-positions`">
                            <span class="todo-item-content">Positions</span>
                        </router-link>
                    </div>
                    <router-link v-if="isSetupComplete" class="btn btn-primary ml-2 mt-2" :to="{name: 'settings'}">
                        Finish &amp; Go to Client
                    </router-link>
                </div>
            </div>
        </nav>
    </div>

    <div class="flex-page-content flex-container">
        <router-view :client="client" :setupStatus="setupStatus" @refreshClient="getClientSetupStatus(); $emit('refreshClient')"/>
    </div>
</div>
</template>

<script>
// The setup-status response has more keys than these; only the steps shown in the
// sidebar gate the finish button
const SETUP_STEPS = ['services', 'companies', 'locations', 'pay_groups', 'org_levels', 'positions']

export default {
    props: ['client', ],
    computed: {
        activeTitle() {
            return this.$store.state.pageTitle
        },
        activeRoute() {
            return this.$route.name
        },
        isSetupComplete() {
            return SETUP_STEPS.every(step => this.setupStatus[step])
        },
    },
    mounted() {
        this.getClientSetupStatus()
    },
    data() {
        return {
            setupStatus: {
                'services': false,
                'companies': false,
                'locations': false,
                'pay_groups': false,
                'org_levels': false,
                'positions': false,
            },
        }
    },
    methods: {
        getClientSetupStatus() {
            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/setup-status`
            this.$api.get(url).then((resp) => {
                this.$store.dispatch('STOP_LOADING')
                this.setupStatus = resp
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>

<style scoped>
a.todo-item, a.todo-item:hover, a.todo-item .todo-item-content, a.todo-item:hover .todo-item-content {
    text-decoration: none;
}
.todo-item::before {
    height: 24px;
    width: 24px;
    margin-right: 8px;
}
.todo-item-completed::before {
    font-size: 0.9rem;
    padding-top: 3px;
    padding-left: 5px;
    background-color: #007238;
}
@media (min-width: 576px) {
    .todo-item-content {
        padding-top: 4px;
        padding-bottom: 2px;
    }
}
@media (min-width: 768px) {
    .flex-page-sidebar {
        min-height: calc(100vh - 60px);
    }
}
</style>
